import React, { Component, Fragment } from 'react'
import './PerformanceRow.css'

class StdPerfRow extends Component {
  formatPercent(number) {
    return number !== null ? `${parseFloat(number * 100).toFixed(2)}%` : '-'
  }
  formatDate(string) {
    return new Date(string).toLocaleDateString([], { timeZone: 'UTC' })
  }

  renderEmptyCells = num => {
    const cells = []
    for (let i = 0; i < num; i++) {
      cells.push(<td key={i}></td>)
    }
    return cells
  }

  setupMorningstarUrl(fund) {
    // Set up the Morningstar URL
    var mainDomain = ''
    if (fund.type === 'ETF') {
      mainDomain = 'etfs'
    } else if (fund.type === 'MF') {
      mainDomain = 'funds'
    }

    let subDomain = ''
    switch (fund.exchangeCode) {
      case 'NASDAQ':
        subDomain = 'xnas'
        break
      case 'Arca':
      case 'NYSE':
        subDomain = 'arcx'
        break
      case 'BATS ECN - RDFD':
        subDomain = 'bats'
        break
      default:
        subDomain = 'xnas'
    }

    fund.msUrl = `https://www.morningstar.com/${mainDomain}/${subDomain}/${fund.ticker}/performance`

    return fund
  }

  render() {
    const { fund, wtRegion } = this.props

    if (fund.stdPerformance === null) {
      return null
    }

    const hide = ['BMK', 'MF', 'WTIDX'].includes(fund.type)
    const yearStart = new Date(new Date().getFullYear(), 0, 1)
    const yearStartISO = yearStart.toISOString()
    const hideYTD = yearStartISO <= this.props.fund.inceptionDate ? true : false
    let title;
    if (fund.type === 'BLEND') {
        title = 'PORTFOLIO:';
    } else if (fund.type === 'COD') {
        title = 'PORTFOLIO:';
    } else {
        title = 'MODEL:';
    }
    // const inceptionDate = new Date(fund.inceptionDate).toLocaleDateString()

    if (fund.type === 'BLEND' || fund.type === 'WTMOD' || fund.type === 'COD' ) {
      // Step 1: Setup msUrl for each underlying fund
      if (fund.underlyingPerformances && fund.underlyingPerformances.length > 0) {
        fund.underlyingPerformances = fund.underlyingPerformances.map(underlyingFund => {
          return underlyingFund.fundPageURL ? underlyingFund : this.setupMorningstarUrl(underlyingFund)
        })
      }
      return (
        <Fragment>
          <tr className='greyline' style={{ backgroundColor: 'lightgrey', fontWeight: 'bold' }}>
            <td width='70' className='textLeft'>{title}</td>
            <td width='100' className='textLeft'>
              {' '}
              {fund.name.replace(/&amp;/g, '&').toUpperCase()} (NAV)
            </td>
            <td className='textCenter'>{this.formatDate(fund.inceptionDate)} </td>
            <td className='textCenter'>{this.formatPercent(fund.stdPerformance[0].mtdNAV)}</td>
            <td className='textCenter'>{this.formatPercent(fund.stdPerformance[0].mos3NAV)}</td>
            <td className='textCenter'>{this.formatPercent(fund.stdPerformance[0].ytdNAV)}</td>
            <td className='textCenter'>{this.formatPercent(fund.stdPerformance[0].yrs1NAV)}</td>
            <td className='textCenter'>{this.formatPercent(fund.stdPerformance[0].yrs3NAV)}</td>
            <td className='textCenter'>{this.formatPercent(fund.stdPerformance[0].yrs5NAV)}</td>
            <td className='textCenter'>{this.formatPercent(fund.stdPerformance[0].yrs10NAV)}</td>
            <td className='textCenter'>{this.formatPercent(fund.stdPerformance[0].inceptionNAV)}</td>
            <td className='textCenter'>{this.formatPercent(fund.stdPerformance[0].commonPeriodNAV)}</td>
          </tr>

          {fund.underlyingPerformances && fund.underlyingPerformances.length > 0
            ? fund.underlyingPerformances.map((underlyingFund, index) => (
                <tr key={index} className='greyline'>
                  <td>
                    {underlyingFund.type === 'BMK' ? (
                      underlyingFund.ticker.toUpperCase()
                    ) : underlyingFund.fundPageURL ? (
                      <a className='tickerLink' href={underlyingFund.fundPageURL} target='_new'>
                        {underlyingFund.ticker}
                      </a>
                    ) : (
                      <a className='tickerLink' href={underlyingFund.msUrl} target='_new'>
                        {underlyingFund.ticker}
                      </a>
                    )}
                  </td>
                  <td className='textLeft'>{`${underlyingFund.name.replace(/&amp;/g, '&')} (NAV) BLEND`}</td>
                  <td className='textCenter'>{this.formatDate(underlyingFund.inceptionDate)} </td>
                  <td className='textCenter'>{this.formatPercent(underlyingFund.stdPerformance[0].mtdNAV)}</td>
                  <td className='textCenter'>{this.formatPercent(underlyingFund.stdPerformance[0].mos3NAV)}</td>
                  <td className='textCenter'>{this.formatPercent(underlyingFund.stdPerformance[0].ytdNAV)}</td>
                  <td className='textCenter'>{this.formatPercent(underlyingFund.stdPerformance[0].yrs1NAV)}</td>
                  <td className='textCenter'>{this.formatPercent(underlyingFund.stdPerformance[0].yrs3NAV)}</td>
                  <td className='textCenter'>{this.formatPercent(underlyingFund.stdPerformance[0].yrs5NAV)}</td>
                  <td className='textCenter'>{this.formatPercent(underlyingFund.stdPerformance[0].yrs10NAV)}</td>
                  <td className='textCenter'>{this.formatPercent(underlyingFund.stdPerformance[0].inceptionNAV)}</td>
                  <td className='textCenter'>{this.formatPercent(underlyingFund.stdPerformance[0].commonPeriodNAV)}</td>
                </tr>
              ))
            : null}
        </Fragment>
      )
    }

    return (
      <Fragment>
        <tr className='greyline'>
          <td width='70' className='textLeft'>
            {fund.type === 'BMK' ? (
              fund.ticker.toUpperCase()
            ) : fund.fundPageURL ? (
              <a className='tickerLink' href={fund.fundPageURL} target='_new'>
                {fund.ticker}
              </a>
            ) : (
              <a className='tickerLink' href={fund.msUrl} target='_new'>
                {fund.ticker}
              </a>
            )}
          </td>
          {['BMK', 'WTIDX'].includes(fund.type) ? (
            <td width='300' className='textLeft'>
              {fund.name.replace(/&amp;/g, '&')}
            </td>
          ) : (
            <td width='300' className='textLeft'>
              {`${fund.name.replace(/&amp;/g, '&')} (NAV)`}
            </td>
          )}

          <td className='textCenter'> {this.formatDate(fund.inceptionDate)}</td>
          {wtRegion === 'US' && (
            <Fragment>
              <td className='textCenter'>{this.formatPercent(fund.stdPerformance.slice(-1)[0].mtdNAV)}</td>
              <td className='textCenter'>{this.formatPercent(fund.stdPerformance.slice(-1)[0].mos3NAV)}</td>
              <td className='textCenter'>{hideYTD === true ? '-' : this.formatPercent(fund.stdPerformance.slice(-1)[0].ytdNAV)}</td>
            </Fragment>
          )}
          <td className='textCenter'>{this.formatPercent(fund.stdPerformance.slice(-1)[0].yrs1NAV)}</td>
          <td className='textCenter'>{this.formatPercent(fund.stdPerformance.slice(-1)[0].yrs3NAV)}</td>
          <td className='textCenter'>{this.formatPercent(fund.stdPerformance.slice(-1)[0].yrs5NAV)}</td>
          <td className='textCenter'>{this.formatPercent(fund.stdPerformance.slice(-1)[0].yrs10NAV)}</td>
          {fund.type === 'BMK' ? <td className='textCenter'>-</td> : <td className='textCenter'>{this.formatPercent(fund.stdPerformance.slice(-1)[0].inceptionNAV)}</td>}
          <td className='textCenter'>{this.formatPercent(fund.stdPerformance.slice(-1)[0].commonPeriodNAV)}</td>
        </tr>
        {!hide && (
          <tr className='whiteline'>
            <td width='50' className='textLeft'>
              &nbsp;
            </td>
            <td width='300' className='textLeft'>
              {`${fund.name.replace(/&amp;/g, '&')} (MP)`}
            </td>
            <td className='textCenter'> {this.formatDate(fund.inceptionDate)} </td>
            {wtRegion === 'US' && (
              <Fragment>
                <td className='textCenter'>{this.formatPercent(fund.stdPerformance.slice(-1)[0].mtdMP)}</td>
                <td className='textCenter'>{this.formatPercent(fund.stdPerformance.slice(-1)[0].mos3MP)}</td>
                <td className='textCenter'>{hideYTD === true ? '-' : this.formatPercent(fund.stdPerformance.slice(-1)[0].ytdMP)}</td>
              </Fragment>
            )}
            <td className='textCenter'>{this.formatPercent(fund.stdPerformance.slice(-1)[0].yrs1MP)}</td>
            <td className='textCenter'>{this.formatPercent(fund.stdPerformance.slice(-1)[0].yrs3MP)}</td>
            <td className='textCenter'>{this.formatPercent(fund.stdPerformance.slice(-1)[0].yrs5MP)}</td>
            <td className='textCenter'>{this.formatPercent(fund.stdPerformance.slice(-1)[0].yrs10MP)}</td>
            <td className='textCenter'>{this.formatPercent(fund.stdPerformance.slice(-1)[0].inceptionMP)}</td>
            <td className='textCenter'>{this.formatPercent(fund.stdPerformance.slice(-1)[0].commonPeriodMP)}</td>
          </tr>
        )}
      </Fragment>
    )
  }
}

export default StdPerfRow
